<app-cc-detail-dialog [formConfig]="detailFormConfig" [transPartKey]="transPartKey"
                      [formRecord]="formRecord" [(dialogFormVisible)]="detailDialogVisible"
                      [dialogFormTitle]="'page.clearing.trade.table.zoom_trade' | translate">
</app-cc-detail-dialog>
